module.exports = __webpack_public_path__ + "img/9e53557.png";